import { render, staticRenderFns } from "./event-stream.vue?vue&type=template&id=7ddd9fda"
import script from "./event-stream.vue?vue&type=script&lang=js"
export * from "./event-stream.vue?vue&type=script&lang=js"
import style0 from "./event-stream.vue?vue&type=style&index=0&id=7ddd9fda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports